import { Container } from 'react-bootstrap';
import Meta from '../Components/Meta';
import BackButton from '../Components/BackButton';

export default function ShippingPolicyScreen() {
  return (
    <>
      <BackButton />
      <Container className="py-4">
        <Meta
          title="Shipping & Delivery Policy | KCC Parts Distribution"
          description="Shipping and delivery policy for KCC Parts Distribution orders in Canada."
          canonicalPath="/shipping/policy"
        />

        <h1 className="mb-3">Shipping &amp; Delivery Policy</h1>
        <p>
          <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
        </p>

        <h5 className="mt-4">Local Delivery – Greater Ottawa Area</h5>
        <p>We are pleased to offer fast and reliable local delivery within the Greater Ottawa area.</p>
        <ul>
          <li>
            <strong>Free same-day delivery</strong> on business days for orders over{' '}
            <strong>$60 (before tax)</strong> placed before <strong>4:30 PM</strong>.
          </li>
          <li>
            <strong>Flat $9.99 delivery fee</strong> for local orders under $60 (before tax).
          </li>
          <li>Orders placed after 4:30 PM will be delivered on the next business day.</li>
          <li>Business days exclude weekends and statutory holidays.</li>
        </ul>

        <h5 className="mt-3">Shipping Outside the Greater Ottawa Area</h5>
        <p>
          For deliveries outside the Greater Ottawa area or beyond 25 km from our warehouse,
          shipping rates are calculated automatically at checkout.
        </p>
        <p>
          Shipping costs are determined based on item weight, dimensions, delivery destination, and
          carrier rates.
        </p>
        <p>
          We ship using trusted carriers such as Canada Post, Purolator, UPS, and other reputable
          couriers.
        </p>

        <h5 className="mt-3">In-Store / Warehouse Pickup</h5>
        <p>
          Customers may pick up their orders free of charge from our warehouse or office location.
          No delivery or handling fees apply. Pickup is subject to order readiness confirmation.
        </p>

        <h5 className="mt-3">Delivery Timeframes</h5>
        <p>
          Local delivery is typically same day or next business day. Regional and national delivery
          times depend on the carrier.
        </p>
        <p>
          Delivery timelines are estimates and may be affected by weather, carrier delays, or
          unforeseen circumstances.
        </p>

        <h5 className="mt-3">Important Notes</h5>
        <p>
          Orders are processed on business days only. We are not responsible for carrier-related
          delays once an order has shipped.
        </p>
      </Container>
    </>
  );
}
